import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpErrorResponse } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { from, throwError } from "rxjs";
import { Router } from '@angular/router';

@Injectable({
  providedIn: "root",
})
export class ConcurrentAccessInterceptorService implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(req, next) {
    return next.handle(req).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse && err.status === 403 && err.statusText.includes("Concurrent access is forbidden")) {
          return from(this.router.navigateByUrl("/concurrent-access"));
        }
        return throwError(err);
      })
    );
  }
}
